import React from "react";
import { Link } from "react-router-dom";

type Props = { children: React.ReactNode };

type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(): void {}

  render() {
    if (this.state.hasError) {
      return (
        <main id="contenido-principal" className="error-boundary" style={{ padding: "5rem 1.25rem", textAlign: "center" }}>
          <h1>Algo no ha ido bien</h1>
          <p>Ha ocurrido un error inesperado. Puedes volver al inicio e intentarlo de nuevo.</p>
          <p>
            <Link to="/">Ir al inicio</Link>
          </p>
          <p>
            <button type="button" onClick={() => this.setState({ hasError: false })}>
              Reintentar
            </button>
          </p>
        </main>
      );
    }
    return this.props.children;
  }
}
